import { combineReducers } from 'redux'
import form from './form'

const parentsReducer = combineReducers({
  form
})

export default parentsReducer
